
console.log(
    "%c🚀 This website design and development by %cOneOnic Solutions %chttps://oneonic.com/",
    "background: black; color: white; font-size: 16px; padding: 8px; font-family: 'Roboto', sans-serif; font-weight: 300; letter-spacing: 1.5px;",
    "background: black; color: orange; font-size: 16px; padding: 8px; font-family: 'Roboto', sans-serif; font-weight: 300; letter-spacing: 1.5px;",
    "background: black; color: white; font-size: 16px; padding: 8px; font-family: 'Roboto', sans-serif; font-weight: 300; font-style: italic; letter-spacing: 1.5px;"
);

/* slideshow js start */

var slideshow = new Swiper ('.osr-slideshow', {
    slidesPerView: 1,
	spaceBetween: 20,
    speed:2000,
    effect: 'fade',
    autoplay: {
      delay: 2000,
    },
    loop: true,
}); 

/* slideshow js end */

/* marquee slider js start */

var smoothSwiper = new Swiper ('.osr-marquee-logo-slider', {
    speed:18000,
		direction: 'horizontal',
        autoplay: {
          delay: 0,
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        freeMode: true,
        breakpoints: {
          0: {
              spaceBetween: 20
          },
          768: {
              slidesPerView: 'auto',
              spaceBetween: 40
          }
      }
	}); 

/* marquee slider js end */

/* tab zigzag js start */

// document.addEventListener("DOMContentLoaded", function () {
//     const tabs = document.querySelectorAll(".osr-tab-zigzag-tab");
//     const contents = document.querySelectorAll(".osr-tab-zigzag-content");

//     if (tabs.length > 0 && contents.length > 0) {
//         tabs[0].classList.add("active");
//         contents[0].classList.add("active");

//         tabs.forEach(tab => {
//             tab.addEventListener("click", function () {
//                 const targetTab = this.getAttribute("data-tab");
//                 tabs.forEach(t => t.classList.remove("active"));
//                 contents.forEach(c => c.classList.remove("active"));
//                 this.classList.add("active");
//                 document.querySelector(`.osr-tab-zigzag-content[data-tab="${targetTab}"]`).classList.add("active");
//             });
//         });
//     }
// });

/* tab zigzag js end */

/* testimonial js start */

function initTestimonialSlider() {
    var nextEl, prevEl;
    var isMobile = window.matchMedia("(max-width: 992px)").matches; // More reliable breakpoint check

    if (isMobile) {
        nextEl = '.osr-testimonial-next-mobile';
        prevEl = '.osr-testimonial-prev-mobile';
    } else {
        nextEl = '.osr-testimonial-next-desktop';
        prevEl = '.osr-testimonial-prev-desktop';
    }

    return new Swiper('.osr-testimonial-slider', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        }
    });
}

var testimonial = initTestimonialSlider();

window.addEventListener('resize', function () {
    if (testimonial) {
        testimonial.destroy(true, true);
    }
    testimonial = initTestimonialSlider();
});

/* testimonial js end */

/* product accordions js start */

  document.querySelectorAll('.osr-product-info-accordian-box').forEach((box) => {
  const header = box.querySelector('.osr-product-info-accordian-box-header');
  const content = box.querySelector('.osr-product-info-accordian-box-content-data');
  const caretUp = box.querySelector('.osr-caret-up-button');
  const caretDown = box.querySelector('.osr-caret-down-button');

  content.style.maxHeight = '0px';

  header.addEventListener('click', () => {
    const isOpen = content.classList.contains('open');

    document.querySelectorAll('.osr-product-info-accordian-box-content-data').forEach((otherContent) => {
      if (otherContent !== content) {
        otherContent.classList.remove('open');
        otherContent.style.maxHeight = '0px';
        otherContent.parentElement.querySelector('.osr-caret-up-button').style.display = 'none';
        otherContent.parentElement.querySelector('.osr-caret-down-button').style.display = 'inline-block';
      }
    });

    if (isOpen) {
      content.classList.remove('open');
      content.style.maxHeight = '0px';
      caretUp.style.display = 'none';
      caretDown.style.display = 'inline-block';
    } else {
      content.classList.add('open');
      content.style.maxHeight = content.scrollHeight + 'px';
      caretUp.style.display = 'inline-block';
      caretDown.style.display = 'none';
    }
  });
});

/* product accordions js end */

/* card slider js start */

function initCardSlider() {
    var nextEl, prevEl;
    var isMobile = window.matchMedia("(max-width: 992px)").matches; 

    if (isMobile) {
        nextEl = '.osr-card-slider-next-mobile';
        prevEl = '.osr-card-slider-prev-mobile';
    } else {
        nextEl = '.osr-card-slider-next-desktop';
        prevEl = '.osr-card-slider-prev-desktop';
    }

    return new Swiper('.osr-card-slider', {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        breakpoints: {
          0: {
              slidesPerView: 1.5,
              spaceBetween: 20
          },
          768: {
              slidesPerView: 2,
              spaceBetween: 20
          },
          992: {
              slidesPerView: 3,
              spaceBetween: 20
          }
      }
    });
}

var card = initCardSlider();

if(card){
  window.addEventListener('resize', function () {
      if (card) {
          card.destroy(true, true);
      }
      card = initCardSlider();
  });
}
/* card slider js end */

/* testimonial b js start */

var testimonialSliderB = new Swiper(".osr-testimonial-b-slider", {
  spaceBetween: 20,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 2000,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      centeredSlides: false
    },
    768: {
      slidesPerView: 2,
      centeredSlides: true
    },
    1024: {
      slidesPerView: 3,
      centeredSlides: true
    }
  }
});

/* testimonial b js end */

/* infinite slider js start */

var smoothSwiper = new Swiper ('.osr-infinite-slider', {
    speed:5000,
    direction: 'horizontal',
    zoom: true,
    loop: true,
    slidesPerView: "auto",
    freeMode: true,
	keyboard: {
      enabled: true,
      onlyInViewport: false
    },
	mousewheel: {
	   invert: true
    },
    autoplay: {
      delay: 0
    }
}); 

/* infinite slider js end */

/* marquee slider 2 js start */

var marqueeSlider = new Swiper ('.osr-slider-container', {
    speed:18000,
		direction: 'horizontal',
        autoplay: {
          delay: 0,
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        freeMode: true,
	}); 

/* marquee slider 2 js end */

/* logo slider 2 js start */

var logoSlider = new Swiper ('.osr-logo-slider-wrap', {
    speed:18000,
		direction: 'horizontal',
        autoplay: {
          delay: 0,
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        freeMode: true,
	}); 

/* logo slider 2 js end */

/* collection testimonial js start */

var collectionTestimonialSlider =  new Swiper (".osr-collection-testimonial-slider", {
  slidesPerView: 3,
  spaceBetween: 20,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 2000,
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    768: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  }
});

/* collection testimonial js end */

/* product order time js start */

function getFormattedDate(daysToAdd = 7) {
    const today = new Date();
    today.setDate(today.getDate() + daysToAdd);

    const options = { weekday: 'long', day: '2-digit', month: 'short' };
    return today.toLocaleDateString('en-GB', options);
}

document.addEventListener("DOMContentLoaded", function () {
    const dateElement = document.querySelector(".osr-product-text-wrap-time");
    if (dateElement) {
        dateElement.textContent = getFormattedDate();
    }
});

/* product order time js end */

document.addEventListener("DOMContentLoaded", function () {
    const images = document.querySelectorAll("img");
    images.forEach(img => {
        img.onload = function () {
            if (!img.hasAttribute("width") && img.naturalWidth && img.naturalHeight) {
                img.setAttribute("width", img.naturalWidth);
                img.setAttribute("height", img.naturalHeight);
            }
        };
    });
});